import { section } from "@/glow";
import { animateStandard, shouldAnimate } from "@/lib/animation";

section("password", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animatePassword = animateStandard(this.container);
    }
  },

  onUnload() {
    this.animatePassword?.destroy();
  },
});
